interface data {
  navlinkMobile: string[];
  navlink: string[];
}
export const words: data = {
  navlinkMobile: ["TvShow", "Movies", "Search"],
  navlink: ["TvShow", "Movies", "Search"],
};
